import * as PricelistDetailModels from '../../models/pricelist-detail/pricelist-detail';
import { PricelistDetailSearchModel } from '../../models/pricelist-detail/pricelist-detailSearch';


export class Get {
  static readonly type = '[PricelistDetail] Get';
  constructor(public PricelistDetailId: number) { }
}

export class Set {
  static readonly type = '[PricelistDetail] Set';
  constructor(public PricelistDetail: PricelistDetailModels.PricelistDetailModel) { }
}

export class Delete {
  static readonly type = '[PricelistDetail] Delete';
  constructor(public PricelistDetail: PricelistDetailModels.PricelistDetailModel) { }
}

export class GetList {
  static readonly type = '[PricelistDetail] List';
  constructor(public Search: PricelistDetailSearchModel) { }
}

export class SetSearch {
  static readonly type = '[PricelistDetail] Set Search';
  constructor(public Search: PricelistDetailSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[PricelistDetail] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[PricelistDetail] Set List Page';
  constructor(public Search: PricelistDetailSearchModel) { }
}

export class Insert {
  static readonly type = '[PricelistDetail] Insert';
  constructor(public PricelistNewDetail: PricelistDetailModels.PricelistDetailInsertModel) { }
}

export class ResetSave {
  static readonly type = '[PricelistDetail] ResetSave';
  constructor() { }
}

export class ImportPricelist {
  static readonly type = '[PricelistDetail] ImportPricelist';
  constructor( public formData: FormData ) {}
}

export class DisposeSearch {
  static readonly type = '[PricelistDetail] DisposeSearch';
  constructor() { }
}

export class ImportResponseDispose {
  static readonly type = '[PricelistDetail] ImportResponseDispose';
  constructor() { }
}
